import { Subcontractor } from '../../models';
import { SUBCONTRACTORS } from '../prototype/subcontractors-data';

/** Labor-pool subcontractors — from the prototype SUBCONTRACTORS. */
export const SUBCONTRACTORS_SEED: readonly Subcontractor[] = (SUBCONTRACTORS as any[]).map(
  (s): Subcontractor => ({
    id: s.id,
    name: s.name ?? '',
    trade: s.trade ?? '',
    trades: Array.isArray(s.trades) ? s.trades : [],
    crew: s.crew ?? 0,
    hrsWk: s.hrsWk ?? 0,
    availFrom: s.availFrom ?? '',
    availTo: s.availTo ?? '',
    availDays: Array.isArray(s.availDays) ? s.availDays : undefined,
    contactName: s.contactName ?? '',
    contactPhone: s.contactPhone ?? '',
    address: {
      street: s.address?.street ?? '',
      city: s.address?.city ?? '',
      state: s.address?.state ?? '',
      postalCode: s.address?.postalCode ?? '',
    },
  }),
);
